export default __webpack_public_path__ + "static/media/bullet-list-block-thumbnail-dark.1e1df980.svg";